// extracted by mini-css-extract-plugin
module.exports = {"customSelection":"CustomSelection_customSelection__Zp7Bm","customSelectionInput":"CustomSelection_customSelectionInput__RdOMc"};